importUserLicensesCtrl.$inject = ['$state', '$stateParams', 'adminApi']
export default function importUserLicensesCtrl($state, $stateParams, adminApi) {
  this.domainUuid = $stateParams.domainUuid
  this.importUuid = $stateParams.importUuid
  this.importLicenseContent = {}
  this.licensesLoading = false
  this.puttingChanges = false

  var self = this

  function putChanges() {
    self.puttingChanges = true
    return adminApi
      .putActiveLicenses(self.importUuid, self.importLicenseContent)
      .then(function(response) {
        if (response.status === 'error') {
          self.errorMessage = response.message
        }
        self.puttingChanges = false

        return response.status
      })
  }

  this.licenseContentLoaded = function(importLicenseContent) {
    self.importLicenseContent = importLicenseContent
    self.licensesLoading = false
  }

  this.saveAndRefresh = function() {
    putChanges().then(function(status) {
      if (status === 'ok') {
        console.log('OK')
        self.importLicenseContent = {}
        getLicenses()
      }
    })
  }

  this.next = function() {
    putChanges().then(
      function(status) {
        if (status === 'ok') {
          $state.go('import-wizard.step5', {
            domainUuid: self.domainUuid,
            importUuid: self.importUuid
          })
        } else {
          alert('Uh oh, something went wrong')
          console.log(status)
        }
      },
      function(reason) {
        alert('Uh oh, something went wrong')
        console.log(status)
      }
    )
  }
}
